import { useEffect } from "react";
import "../../components/BlogPost.css";

export default function ABalancedLife(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="singlePost">
      <div className="singlePostWrapper">
        <img
          className="singlePostImg"
          src="https://images.unsplash.com/photo-1570633041664-49534b849107?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
          alt=""
        />
        <h1 className="singlePostTitle">A balanced life</h1>
        <p className="singlePostDesc">
          I have met many people on my travels who go on holiday with the
          attitude that they want to really indulge themselves.
          <br />
          When asked why they lost their self-control in this way, they reply
          that they earned it and that one has to relax on holiday.
          <br />
          I can see not only where this reasoning comes from, but also its
          benefits. This behavior can reinforce the association of perseverance
          with a positive reward namely the holiday. I still disagree with this
          attitude.
          <br />
          <br />
          Recently, after a long and draining period of my life (my bachelor
          thesis), i also felt the need to take a relaxing break from all my
          hard-built habits and go on holiday.
          <br />
          But after reflecting on my emotions for a while, I decided against
          giving in to this desire.
          <br />
          Here is why:
          <br />
          <br />
          Every human being, even those who live a fulfilled life, will go
          through phases of their life where it will be difficult and sometimes
          impossible to move on.
          <br />
          What distinguishes the fulfilled person from the unfulfilled person is
          the feeling of satisfaction troughout the work.
          <br />
          The feeling I encountered was a clear indication for me that the work
          I had done was not fulfilling me. Instead of giving in to my desire, I
          therefore decided to permanently change course in my life.
          <br />
          <br />
          In your life, ask yourself whenever you don't enjoy what you are doing
          and you feel the need for holidays, are you living the life you want
          to live or do the holidays you seek symbolise compensation for all the
          things you are missing?
        </p>
      </div>
    </div>
  );
}
